<script>
  import { onMount } from "svelte";
  import Header from "@components/Header.svelte";
  import { TextInput, SectionWrapper, Button } from "paxray-components-svelte";
  import LimitationPresetsList from "../components/LimitationPresetsList.svelte";
  import { fetchWithSession } from "lib/util/fetchWithSession.js";
  import { ROUTES } from "@utils/routes.js";

  const urlParams = new URLSearchParams(window.location.search);
  const idLimitation = urlParams.get("idLimitation");
  // Aus einem Projekt heraus geoeffnet (Setup/Blacklisting) fuehren die
  // Brotkrumen dorthin zurueck; aus der Preset-Verwaltung in die Uebersicht.
  const idproject = urlParams.get("idproject");
  const RUECKWEGE = {
    blacklisting: { label: "Exclude Apps & Websites", route: ROUTES.dam.blacklisting },
  };
  const rueckweg = idproject
    ? RUECKWEGE[urlParams.get("from") || "blacklisting"]
    : null;
  const area = rueckweg ? rueckweg.label : "Limitation Presets";
  const areaHref = rueckweg
    ? `${rueckweg.route}?idproject=${idproject}`
    : ROUTES.dam.presets.root;
  let name = "";

  function updateName() {
    if (idproject) return;
    fetchWithSession(`/api/damprojects/limitation-presets/${idLimitation}`, {
      method: "PATCH",
      body: JSON.stringify({ name }),
    }).then((response) => response.json());
  }

  onMount(() => {
    fetchWithSession(`/api/damprojects/limitation-presets`)
      .then((res) => res.json())
      .then((data) => {
        const current = data.find((preset) => String(preset.id) === idLimitation);
        if (current) name = current.name;
      })
      .catch((err) => {
        console.log(err);
      });
  });
</script>

<Header
  {area}
  {areaHref}
  projectHref={idproject ? `${ROUTES.dam.progress}?${new URLSearchParams({ idproject }).toString()}` : ""}
  breadcrumb={name || "Preset"}
  tooltipText="Rules of this preset. Matching applications and websites are excluded from data collection (blacklist) or are the only ones recorded (whitelist)."
  hideProjectName={!idproject}
/>

<SectionWrapper fullscreen={true} seamless={true} seamlessPadding={true}>
  <div class="main" slot="main">
    <div class="name_row">
      <TextInput labelText="Name" id="name" name="name" bind:value={name} readonly={Boolean(idproject)} />
      {#if !idproject}
        <Button kind="primary" text="Save" on:click={updateName} />
      {/if}
    </div>
    <LimitationPresetsList {idLimitation} editable={!idproject} />
  </div>
</SectionWrapper>

<style>
  /* Ohne width: 100% schrumpft der Bereich im SectionWrapper auf den
     breitesten Inhalt - die Seite nutzte nur die halbe Breite. */
  .main {
    width: 100%;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .name_row {
    display: flex;
    align-items: flex-end;
    gap: 1rem;
  }

  .name_row > :global(:first-child) {
    flex: 1 1 auto;
  }
</style>
